// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"dfb9ede7","820":"b2bf54bd"}[chunkId] + ".chunk.js";
};